import React, { useEffect, useState } from 'react';
import styled, { css } from 'styled-components/macro';
import { FieldProps } from 'formik';
import InputMask, { MaskOptions } from 'react-input-mask';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { useWindowSize } from '../../customHooks/useWindowResize';


const styles = css`
  border-radius: 10px;
  height: 60px;
  display: block;
  border: 1px solid #cbcbcb;
  padding: 5px 20px;
  font-size: 16px;
  color: #708090;
  width: 100%;
  // max-width: 300px;
  font-family: inherit;

  @media (max-width: 600px) {
    max-width: 100%;
  }
`;

export const Input = styled.input<{ hasError?: boolean }>`
  ${styles}

  ${({ hasError }) => hasError && css`
    border-color: #F15642;
  `}
`;

const MaskedInput = styled(({ hasError, ...props }: MaskOptions & { hasError?: boolean }) =>
  <InputMask {...props}/>,
)`
  ${styles}

  ${({ hasError }) => hasError && css`
    border-color: #F15642;
  `}
`;

const Label = styled.label`
  color: #7c8287;
  line-height: 40px;
`;

interface IExtendedFieldProps extends FieldProps {
  type?: string;
}

export const TextField: React.FC<IExtendedFieldProps & MaskOptions> = ({
                                                                         field,
                                                                         form: { touched, errors },
                                                                         mask,
                                                                         type = 'text',
                                                                         ...props
                                                                       }) => {

    const [passType, setPassType] = useState(type);
    const hasLowWidth = useWindowSize();

    if (mask) {
      return (
        <MaskedInput
          mask={mask}
          hasError={!!errors[field.name]}
          // disabled={isSubmitting}
          {...field}
          {...props}
        />
      );
    }

    return type === 'password' ? (
      <div>
        <Input style={{ display: 'inline-block', marginLeft: hasLowWidth ? -15 : 0 }}
               hasError={!!errors[field.name]}
               {...field}
               {...props}
               type={type === 'password' ? passType : type}
        />
        {passType === 'password' ?
          <FontAwesomeIcon className={'cursor-pointer'}
                           onClick={() => setPassType('text')} icon={faEye} style={{ marginLeft: -35 }}/>
          :
          <FontAwesomeIcon className={'cursor-pointer'}
                           onClick={() => setPassType('password')} icon={faEyeSlash} style={{ marginLeft: -35 }}/>}
      </div>
    ) : (
      <Input
        hasError={!!errors[field.name]}
        {...field}
        {...props}
        type={type}
      />
    );
  }
;

interface IOwnProps {
  className?: string;
  label: string;
}

export const LabeledTextField: React.FC<FieldProps & IOwnProps & MaskOptions> = ({
                                                                                   className,
                                                                                   label,
                                                                                   ...props
                                                                                 }) => (
  <div className={className}>
    <Label>{label}</Label>
    <TextField {...props} />
  </div>
);
